import React from "react";
import "../styles/partners.css";

/**
 * Partners — robust infinite logo marquee.
 * Renders the list TWICE and scrolls exactly -50% so the loop is seamless
 * regardless of how many logos are in the list (no hardcoded width math).
 */
const Partners = (props) => {
  const list = props.list || [];
  const renderSet = (copyId) =>
    list.map((logo, i) => (
      <div className="pm-slide" key={`${copyId}-${i}`}>
        <img src={logo} alt={props.alt ? props.alt(i) : "Partner logo"} />
      </div>
    ));

  return (
    <section className="pm-section">
      {props.title && <h2 className="pm-title">{props.title}</h2>}
      <div className="pm-viewport">
        <div
          className="pm-track"
          style={{ "--pm-count": list.length }}
        >
          {renderSet("a")}
          {renderSet("b")}
        </div>
      </div>
    </section>
  );
};

export default Partners;
